module.exports = __webpack_public_path__ + "static/media/promo-image-apoteka.fc8147bb.png";